import { FunctionComponent } from "react";
import { Link, useLocation } from "react-router-dom";
import { TopNavProps } from "src/utils/types/NavigationTypes";
import { SERVICES_MENU, CONTACT_MENU } from "src/utils/types/NavigationLinks";
import DropdownMenu from "../DropdownMenu";
import LogoSection from "../LogoSection";
import Button from "../../generic/Button"
import { types } from "../../../utils";


const TopNav: FunctionComponent<TopNavProps> = ({ logoOnly = false }) => {
  const { pathname } = useLocation();

  return (
   <nav className="w-full justify-between items-center hidden md:flex">
   
      <LogoSection />
      
      {!logoOnly && (
        <NavigationMenu currentPath={pathname} />
      )}
    </nav>
  );
};

const NavigationMenu: FunctionComponent<{ currentPath: string }> = ({ currentPath }) => (
  <div className="flex justify-between items-start lg:w-[40%]">
    <HomeLink isActive={currentPath === '/'} />
    <ServicesDropdown />
    <ContactDropdown />
    <LoginButton />
  </div>
);


const HomeLink: FunctionComponent<{ isActive: boolean }> = ({ isActive }) => {
  const baseStyles = 'uppercase text-[17px] pb-2';
  const activeStyles = isActive ? 'border-b-4 border-primary' : '';
  
  return (
    <Link to='/' className={`${baseStyles} ${activeStyles}`}>
      Home
    </Link>
  );
};


const ServicesDropdown: FunctionComponent = () => (
  <DropdownMenu title="Services" items={SERVICES_MENU} />
);


const ContactDropdown: FunctionComponent = () => (
  <DropdownMenu title="Contact" items={CONTACT_MENU} />
);


const LoginButton: FunctionComponent = () => (
  <Link to='/auth/login'>
    <Button text='Login' theme={types.buttonTypes.BUTTON_THEME_TYPES.PRIMARY} styles='rounded-none' />
  </Link>
);


export default TopNav;





